<!--
套组详情卡片
20220331
-->
<template>
  <van-popup
    v-model="showSetDetails"
    position="bottom"
    class="subplate_set"
  >
    <div class="subplate_box">
      <template v-if="setDetailGetOver == 1">
        <div class="cover"
          v-lazy:background-image="{
            src: setDetail.cover_arr[0],
            loading: '/static/img/img_load.gif',
            error: '/static/img/img_blank.png'
          }"
          v-if="setDetail.cover_arr.length"
        ></div>

        
        <div class="brandandnumber"><div class="logo"
          v-lazy:background-image="{
            src: setBrandDetail.logo ? setBrandDetail.logo : '/static/img/brand_blank.png',
            error: '/static/img/brand_blank.png'
          }"
        ></div><div class="brand" :class="{'skeleton_brand': setDetailGetOver != 1}" :title="setBrandDetail.title">{{setBrandDetail.title}}</div><div class="number">{{setDetail.setnumber}}</div></div>
        <div class="title" :class="{'skeleton_title': setDetailGetOver != 1}">{{setDetail.title}}</div>
        <div class="subtitle" :class="{'skeleton_subtitle': setDetailGetOver != 1}">{{setDetail.subtitle}}</div>
        
        <div class="setindex_param">
          <div class="item_param">
            <div class="num">{{setDetail.released_year ? setDetail.released_year : '--'}}</div>
            <div>年份</div>
            <div class="sign sign_newrelease" v-if="setDetail.sign_newrelease">
              <span>新品</span>
            </div>
            <div class="sign sign_outofprint" v-else-if="setDetail.sign_outofprint">
              <span>{{setDetail.sign_outofprintjust ? "绝版不久" : "已绝版"}}</span>
            </div>
            <div class="sign sign_outofprintsoon" v-else-if="setDetail.sign_outofprintsoon">
              <span>即将绝版</span>
            </div>
            <div class="sign sign_newadd" v-else-if="setDetail.sign_newadd">
              <span>新收录</span>
            </div>
          </div>
          <div class="item_param">
            <div class="num">{{setDetail.pcs ? setDetail.pcs : '--'}}</div>
            <div>零件数</div>
            <div class="bricktype"
              :class="'color_'+setDetail.bricktype"
              v-if="setDetail.bricktype > 1"
            >
              <span v-if="setDetail.bricktype==2">大颗粒</span>
              <span v-else-if="setDetail.bricktype==3">迷你颗粒</span>
              <span v-else-if="setDetail.bricktype==4">微钻颗粒</span>
              <span v-else-if="setDetail.bricktype==5">巨型</span>
              <span v-else-if="setDetail.bricktype>=6">特殊</span>
              <!-- <i class="material-icons">&#xe88f;</i> -->
            </div>
          </div>
          <div class="item_param">
            <div class="num"
              v-if="setDetail.age_lower > 0 && setDetail.age_upper > 0"
            >
              {{setDetail.age_lower}}-{{setDetail.age_upper}}
            </div>
            <div class="num"
              v-else-if="setDetail.age_lower > 0 && !(setDetail.age_upper > 0)"
            >
              {{setDetail.age_lower}}+
            </div>
            <div class="num" v-else>--</div>
            <div>年龄</div>
          </div>
        </div>

        <div class="table_param_wrap" v-if="hasParam">
          <div class="table_param">
            <dl v-if="setDetail.released">
              <dt>发售/发布</dt>
              <dd>{{setDetail.released}}</dd>
            </dl>
            <dl v-if="setDetail.outofprint">
              <dt>绝版日期</dt>
              <dd>{{setDetail.outofprint}}</dd>
            </dl>
            <dl v-if="setDetail.weight">
              <dt>重量</dt>
              <dd>{{setDetail.weight}} kg</dd>
            </dl>
            <dl v-if="setDetail.minifigs">
              <dt>人仔数</dt>
              <dd>{{setDetail.minifigs}}</dd>
            </dl>
            <dl v-if="setDetail.package_size">
              <dt>包装尺寸</dt>
              <dd>{{setDetail.package_size}} cm</dd>
            </dl>
            <dl v-if="setDetail.package_type">
              <dt>包装形式</dt>
              <dd>{{setDetail.package_type}}</dd>
            </dl>
            <dl v-if="setDetail.size">
              <dt>成品尺寸</dt>
              <dd>{{setDetail.size}} cm</dd>
            </dl>
            <dl v-if="setDetail.scale">
              <dt>模型比例</dt>
              <dd>1 : {{setDetail.scale}}</dd>
            </dl>
            <dl class="tr_param_ean" v-if="setDetail.ean">
              <dt>EAN条码</dt>
              <dd>{{setDetail.ean}}
                <barcode v-bind:value="setDetail.ean" 
                  width="1" height="30" format="EAN13"
                  :displayValue="false"
                  background="transparent"
                  :flat="true"
                  margin="0"
                ></barcode>
              </dd>
            </dl>
            <dl v-if="setDetail.remarks">
              <dt>备注</dt>
              <dd>{{setDetail.remarks}}</dd>
            </dl>
          </div>

        </div>

        <div class="form_item form_item_btn">
          <div class="form_btn_part half">
            <div class="form_btn btn btn_color_4 btn_round ink" v-waves
              @click="showSetDetails = false;"
            >关闭</div>
          </div>
          <div class="form_btn_part">
            <router-link class="form_btn btn btn_color_2 btn_round btn_outline ink"
              v-waves
              :to="(setBrand && setNumber) ?
                {
                  name: 'SetIndex',
                  params: {
                    brand: setBrand,
                    setnumber: setNumber,
                  }
                }
                :
                {
                  name: 'SetIndexById',
                  params: {
                    id: setnumberId,
                  }
                }
              "
            >了解更多</router-link>
          </div>
        </div>

      </template>
      <div class="nothing nothing_load" v-if="setDetailGetOver==0">
        <i class="material-icons big">&#xe88b;</i>
        <div>载入中</div>
        <div><small>稍等……</small></div>
      </div>

      <div class="nothing nothing_load" v-if="setDetailGetOver==2">
        <!-- <i class="material-icons big">&#xe88b;</i> -->
        <!-- <div>载入中</div> -->
        <div><small>套组资料载入失败</small></div>
        <a class="btn" @click="pageReload()">点击重新加载</a>
      </div>


    </div>

  </van-popup>

</template>

<script>

import VueBarcode from 'vue-barcode';

export default {
  name: 'SetDetails',
  components: {
    'barcode': VueBarcode
  },
  props: {
    // setnumberId: {
    //   required: false
    // },//套组id
    // setBrand: {
    //   required: false
    // },//套组品牌
    // setNumber: {
    //   required: false
    // },//套组编号
  },
  data () {
    return {
      showSetDetails: false,

      setnumberId: null,//套组id
      setBrand: null,//套组品牌
      setNumber: null,//套组编号

      hasParam: false,//是否有参数表

      setDetailGetOver: 0,//套组资料载入状态 0 载入中 1 成功 2 载入失败

      //套组基本信息
      setDetail: {
        cover_arr: [],
        //cover: '/static/img/img_blank.jpg',
        // title: 'NASA发现者号航天飞机',
        // subtitle: 'NASA Space Shuttle Discovery',
        // brandid: '1',
        // setnumber: '10283',
        // released_year: '2022',
        // pcs: '2354',
        // age_lower: '2',
        // age_upper: '20',
        // released: '2020-07-18',
        // outofprint: '2020-07-18',
        // weight: '1.28',
        // minifigs: '2',
        // package_size: '20x15x56',
        // size: '5x5x8',
        // package_type: '盒装',
        // remarks: '展示盒 内含4款',
        // ean: '6970556359300',
        // bricktype: 3,
        // text: "",
      },

      //当前品牌的信息
      setBrandDetail: {
        //"id": "1",
        //"title": "乐高LEGO",
        //"logo": "http://brick4.com/upload/brand/brand_1.png",
        //"code": "LEGO",
      },



    }
  },
  computed: {

  },
  watch: {},
  created() {
    const _this = this;

  },
  mounted() {

  },
  destroyed() {},
  methods: {

    //打开面板
    showPopup(setnumberId, setBrand, setNumber){
      const _this = this;
      _this.showSetDetails = true;



      if( _this.setnumberId != setnumberId ||
          _this.setBrand != setBrand ||
          _this.setNumber != setNumber ){

        _this.setnumberId = setnumberId;//套组id
        _this.setBrand = setBrand;//套组品牌
        _this.setNumber = setNumber;//套组编号

        _this.setDetailGetOver = 0;

        _this.getSetDetail(function(){
          _this.funHasParam();//判断是否有参数表
        });
      }

    },

    //载入套组详情 开始 ==========================
    getSetDetail(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
        nc: _this.input_nocache,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/detail/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '载入套组详情失败',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            _this.setDetailGetOver = 1;//详情已载入

            let fatch_data = res.data.data;

            _this.setnumberId = fatch_data.id;

            // if( fatch_data.cover ){
            //   fatch_data.cover = _this.$store.state.api.img + fatch_data.cover + '!setcover';
            // }

            fatch_data.cover_arr.forEach(function(cover_n, cover_i, arr){

              if( cover_n ){
                arr[cover_i] = _this.$store.state.api.img + cover_n + '!setcover.webp';
                if( fatch_data.position && !fatch_data.position_img ){
                  fatch_data.position_img = _this.$store.state.api.img + cover_n + '?imageMogr2/extent/!60x60/thumbnail/60x60';
                }
              }

            });

            if( fatch_data.brand.logo ){
              fatch_data.brand.logo = _this.$store.state.api.img + fatch_data.brand.logo + '!brand_s';
            }

            _this.setDetail = fatch_data;
            _this.setBrandDetail = fatch_data.brand;
            _this.setTheme = fatch_data.theme.reverse();

            _this.setBrand = _this.setBrandDetail.code;
            _this.setNumber = _this.setDetail.setnumber;


            //更多的搜索建议
            if( fatch_data.suggest && fatch_data.suggest.length ){
              _this.setSuggest = fatch_data.suggest;
            }

            //优化视频
            //_this.setDetail.text = _this.setDetail.text.replace(/<a href="([^\"]+)" class="video">([^<]+)<\/a>/, '<video preload="auto" controls="controls" autoplay="" style=""><source src="$1" type="video/mp4"></video>');
            _this.setDetail.text = _this.setDetail.text.replace(/<a href="([^\"]+)" class="video">([^<]+)<\/a>/, '<video preload="auto" controls="controls"><source src="$1" type="video/mp4"></video>');


            //console.log(_this.setDetail);
            callback && callback();

          }else{
            _this.setDetailGetOver = 2;//详情载入失败
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            });
          }
        }else{
          _this.setDetailGetOver = 2;//详情载入失败
          _this.$dialog.confirm({
            closeOnPopstate: true,//页面回退时自动关闭
            title: '套组详情拉取失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          });
        }
      }).catch(function (error) {
        console.error(error);

        _this.setDetailGetOver = 2;//详情载入失败

        _this.$dialog.confirm({
          closeOnPopstate: true,//页面回退时自动关闭
          title: '网络不畅，详情拉取失败',
          message: '您可以尝试：',
          confirmButtonText: '刷新重试',
          cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        }).then(() => {
          location.reload(true);
        }).catch(() => {
          window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        });


      });

    },
    //载入套组详情 结束 ==========================

    //判断是否有参数表
    funHasParam(){
      const _this = this;
      if(
        _this.setDetail.released
        || _this.setDetail.outofprint
        || _this.setDetail.weight
        || _this.setDetail.minifigs
        || _this.setDetail.package_size
        || _this.setDetail.package_type
        || _this.setDetail.size
        || _this.setDetail.ean
        || _this.setDetail.remarks
      ){
        _this.hasParam = true;
      } else {
        _this.hasParam = false;
      }
    },



  }
}
</script>



<style lang="less">


</style>


<style lang="less" scoped>


/** 本页二维码 **/
.subplate_set {
  z-index: 2002;
  width: 300px;
  left: 50%;
  margin: 0 auto auto -150px;
  text-align: center;
  border-radius: 20px 20px 0 0;
  padding: 30px;
  box-shadow: 0 0 30px rgba(0,0,0,.5);
  max-height: 98%;

  @media only screen and (min-width: 400px) {
    width: 360px;
    margin: 0 auto auto -190px;
  }
  @media only screen and (min-width: 600px) {
    width: 500px;
    margin: 0 auto auto -250px;
  }

  .subplate_box {
    text-align: left;
    .cover {
      padding-top: 70%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-bottom: 10px;
    }


    .brandandnumber {
      align-items: center;
      display: flex;
      font-size: 16px;
      .logo {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        flex-shrink: 0;
        margin-right: 5px;
        border-radius: 4px;
        /*box-shadow: inset 0 0 5px rgba(0,0,0,.1);*/
      }
      .brand {
        /*flex: 1;*/
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 5px;
        overflow: hidden;
        &.skeleton_brand {
          width: 100px;
          height: 20px;
          background-color: #f4f4f4;
          background-image: linear-gradient(to right, #f4f4f4 18%, #fcfcfc);
        }
      }
      .number {
        flex-shrink: 0;
        white-space: nowrap;
      }
    }
    .title {
      font-size: 20px;
      font-weight: bold;
      min-height: 20px;
      &.skeleton_title {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: 5px;
          bottom: 5px;
          width: 100%;
          background-color: #f4f4f4;
          background-image: linear-gradient(to right, #e8e8e8 18%, #fcfcfc);
        }
      }
    }
    .subtitle {
      font-size: 16px;
      font-weight: bold;
      color: #e62828;
      min-height: 20px;
      &.skeleton_subtitle {
        width: 70%;
        height: 26px;
        min-height: unset;
        background-color: #f4f4f4;
        background-image: linear-gradient(to right, #f4f4f4 18%, #fcfcfc);
      }
    }

    /** 主参数 **/
    .setindex_param {
      display: flex;
      flex-flow: row;
      text-align: center;
      .item_param {
        flex: 1;
        padding-top: 10px;
        padding-bottom: 10px;
        .num {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    /** 新品标签 **/
    .sign {
      background-color: #ffcf00;
      color: #333;
      display: inline-block;
      padding: 0 10px;
      border-radius: 100px;
      margin: 5px auto 0;
      line-height: 24px;
      &.sign_newrelease {
        background-color: #fff;
        color: #ef3a3a;
        box-shadow: inset 0 0 0 1px #ef3a3a;
      }
      &.sign_newadd {
        background-color: #fff;
        color: #42bf53;
        box-shadow: inset 0 0 0 1px #42bf53;
      }
      &.sign_outofprint {
        background-color: #f4f4f4;
        color: #999;
        box-shadow: inset 0 0 0 1px #999;
      }
      &.sign_outofprintsoon {
        background-color: #333;
        color: #ffcf00;
      }
    }
    /** 零件类型 **/
    .bricktype {
      color: #fff;
      background-color: #ffa317;
      display: inline-block;
      padding: 0 10px;
      border-radius: 100px;
      margin: 5px auto 0;
      cursor: pointer;
      line-height: 24px;
      * {
        vertical-align: top;
        display: inline-block;
        line-height: inherit;
      }
      .material-icons {
        transform: scale(.6);
        margin-right: -5px;
      }
      &.color_2 {
        background-color: #42bf53;
      }
      &.color_3 {
        background-color: #e4b61c;
      }
      &.color_4 {
        background-color: #2b76c6;
      }
    }

    /** 详细参数 **/
    .table_param_wrap{
      background-color: #f4f4f4;
      background-image: linear-gradient(#fff3f3 20%, #f4f4f4 90%);
      border-radius: 10px;
      .table_param {
        padding: 30px;
        dl {
          display: flex;
          padding: 5px 0;
          margin: 0;
          dt {
            flex-shrink: 0;
            padding: 0 0 0 10px;
            margin: 0;
            width: 100px;
            opacity: .6;
          }
          dd {
            flex: 1;
            padding: 0 10px 0 0;
            margin: 0;
            overflow: hidden;
          }
          &:nth-child(even) {
            background-color: rgba(255,255,255,.5);
          }
        }
      }
      .btn_more {
        color: #e62828;
        display: block;
        text-align: right;
        padding: 0 10px;
        line-height: 30px;
      }
    }
    .tr_param_ean /deep/ .vue-barcode-element {
      /*max-width: 100%;*/
    }


    .form_item_btn {
      margin-top: 10px;
      .btn_color_2 {
        background-color: #fff;
        color: #ef3a3a;
      }
    }

    .nothing_load {
      background-image: none!important;

    }

  }
}
</style>


// WEBPACK FOOTER //
// src/components/SetDetails.vue